export const slidesExtensionPricingData = [{
    title: "Features",
    features: [
        "Convert PDF to Editable Slides",
        "1 Credit = 1 Page Conversion",
        "Secure Transmission",
        "Priority Support"
    ]
}, {
    title: "Subscription Plans",
    plans: [{
        name: "sub100",
        label: "100 Credits",
        credits: 100,
        amount: 10,
        lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/238ae6d9-42ef-40c1-ab3d-d6eb148f2a8c?enabled=970840`
        //paylinks are also defined in pricing page component. review accordingly
    }, {
        name: "sub500",
        label: "500 Credits",
        credits: 500,
        amount: 25,
        lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/1d4940a4-aadc-4b06-a2fc-8d3db585bd17?enabled=970843`
        //paylinks are also defined in pricing page component. review accordingly
    }, {
        name: "sub1000",
        label: "1000 Credits",
        credits: 1000,
        amount: 40,
        lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/9624301c-c971-49ed-84b4-20e3dacac3df?enabled=970844`
        //paylinks are also defined in pricing page component. review accordingly
    }]
}, {
    title: "Top Up Plans",
    plans: [{
        name: "topUp100",
        label: "100 Credits",
        credits: 100,
        amount: 15,
        lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/c14cfaaa-7273-498a-91e9-9360bc0ee2f7?enabled=970835`
        //paylinks are also defined in pricing page component. review accordingly
    }, {
        name: "topUp500",
        label: "500 Credits",
        credits: 500,
        amount: 40,
        lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/d147b22c-8f5c-4d91-83af-74b315fc3a95?enabled=970837`
        //paylinks are also defined in pricing page component. review accordingly
    }, {
        name: "topUp1000",
        label: "1000 Credits",
        credits: 1000,
        amount: 70,
        lemonSqueezyLink: `https://easyimagetotext.lemonsqueezy.com/buy/dac976e6-8012-4817-ac53-4ffe3a195a76?enabled=970838`
        //paylinks are also defined in pricing page component. review accordingly
    }]
}]